var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Portal',{attrs:{"selector":"#portal-button-envelope"}},[(_vm.unread.length)?_c('span',{staticClass:"badge badge-warning"},[_vm._v(_vm._s(_vm.unread.length))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }